/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Panes/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import Check from './Check/index'
import Form from './Form/index'
import Lead from './Lead/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Panes({
  children,
  viewPath = "/App/Account/NewPatient/Content/Panes"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'Form'
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'Form'}>
<Form
  viewPath={`${viewPath}/Form`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Check'}>
<Check
  viewPath={`${viewPath}/Check`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Lead'}>
<Lead
  viewPath={`${viewPath}/Lead`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}